import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { useGetHomepageLeadData } from "../../../api/leadsManagement";
import { iconMapping } from "../../../helpers/leadsManagement";
import { usePermissionStore } from "../../../stores/permissionStore";

const useHomePage = () => {
    const { t } = useTranslation();
    const {mutate, data: homeLeadsData, isLoading: isLoadingHomeLeadsData} = useGetHomepageLeadData();
    const [frequency, setFrequency] = useState("annually")

    useEffect(() => {
        mutate({
            frequency,
            Permission_Token: usePermissionStore.getState().permissionToken ?? ""
        })
    }, [frequency])

    const leadSummary = homeLeadsData?.data?.leadSummaryResponse;
    const graphSummaryData = homeLeadsData?.data?.graphSummaryResponse;


    const overviewData = useMemo(() => {

        if (!leadSummary || isLoadingHomeLeadsData) return []

        return Object.entries(leadSummary).map(([key, value]) => ({
            label: t(`platform.${key}`) || key,
            value: key === "conversionRate" ? `${((value as number) * 100).toFixed(1)}%` : String(value),
            icon: iconMapping(key)
        }));

    }, [leadSummary, isLoadingHomeLeadsData])

    const graphData = useMemo(() => {
        if (!graphSummaryData?.graphData || isLoadingHomeLeadsData) {
            return {
                xAxisData: [],
                yAxisData: []
            };
        }

        const xAxisData = graphSummaryData.graphData.map((item: { x: string; y: number }) => item.x);
        const yAxisData = graphSummaryData.graphData.map((item: { x: string; y: number }) => item.y);

        return {
            xAxisData,
            yAxisData
        };
    }, [graphSummaryData, isLoadingHomeLeadsData])

    const handleFrequencyChange = (_event: React.MouseEvent<HTMLElement>,
        newFrequency: string,) => {
       if (newFrequency !== null) {
            setFrequency(newFrequency)
        }
    }


    return {
        overviewData,
        isLoadingHomeLeadsData,
        handleFrequencyChange,
        frequency,
        graphData
    }



}


export default useHomePage